module.exports = __webpack_public_path__ + "weathericons-regular-webfont.1cd48d78f06d33973d9d.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/weather-icons/font/weathericons-regular-webfont.woff2
// module id = 501
// module chunks = 3